// extracted by mini-css-extract-plugin
export default {"advertDetailServiceList":"c-q_gg","advertDetailServiceList__header":"c-q_gh","advertDetailServiceList__list":"c-q_gi"};